import type {
  PlotOptions,
  PositionedItem,
} from '../../PageConfigProvider/types/item';

const isSingleEntityPlot = (plot: PlotOptions | undefined) => {
  const { chartType, secondaryDimension } = plot || {};
  const metric = plot?.defaultMetricOptions?.[0];
  const dimensionSource = plot?.dimensionSource;

  const isTopN = !!dimensionSource && dimensionSource !== 'primary';

  const isTotalSpendBreakdown =
    (metric === 'total_spend_salary' ||
      metric === 'total_spend_compensation') &&
    !!secondaryDimension;

  const isTreemapBreakdown = chartType === 'treemap' && !!secondaryDimension;

  const isPrimaryEntitySwitcher = !!plot?.primaryEntitySwitcher;

  return (
    chartType === 'volume' ||
    chartType === 'sentiment_review' ||
    metric === 'sentiment_top_bottom' ||
    isTopN ||
    isTotalSpendBreakdown ||
    isTreemapBreakdown ||
    isPrimaryEntitySwitcher
  );
};

export const isSingleEntityChart = (item: PositionedItem) =>
  isSingleEntityPlot(item.plot);
